<template>
  <b-col>
    <b-row>
      <h3 class="mb-3 hp-text-color-black-1">Тарифный план</h3>
    </b-row>
    <b-row>
      <b-col>
        <b-row class="d-flex align-items-center"
          ><h2>{{ price }} ₽ </h2>
          <span class="hp-d-block hp-p1-body"
            >&nbsp;&nbsp;/ {{ unit }}</span
          ></b-row
        ></b-col
      >
      <b-col class="col-4">
        <b-button variant="primary" v-b-modal.modal-1> Сменить тариф </b-button>
      </b-col>
    </b-row>

    <b-modal
      :id="`modal-1`"
      hide-footer
      header-class="align-items-center pt-reduced pb-reduced"
    >
      <template #modal-header="{ close }">
        <h5 class="mb-0">Сменить тариф</h5>

        <b-button
          variant="text"
          @click="close()"
          class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
          style="min-height: 24px"
        >
          <i
            class="ri-close-line hp-text-color-dark-0 lh-1"
            style="font-size: 24px"
          ></i>
        </b-button>
      </template>
      <b-form @submit="onSubmit">
        <b-form-group>
          <b-form-radio-group id="radio-group-1" v-model="tariff_selected" stacked>
            <b-form-radio
              v-for="(item, index) in tariff_table"
              :key="index"
              :value="item.id"
              >{{ item.description }} {{ item.tarif_price }} ₽ /
              {{ item.tarif_unit }}</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
        <b-form-row class="mt-5">
          <b-col
            ><b-button
              class="col-12"
              variant="outline-primary"
              @click="$bvModal.hide('modal-1')"
            >
              Отмена
            </b-button></b-col
          >
          <b-col
            ><b-button class="col-12" variant="primary" type="submit">
              Сохранить
            </b-button></b-col
          >
        </b-form-row>
      </b-form>
    </b-modal>
  </b-col>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormRadio,
  BFormRow,
  BFormRadioGroup,
} from "bootstrap-vue";
import axios from "axios";

export default {
  data() {
    return {
      price: null,
      unit: null,
      tariff_id: null,
      tariff_table: [],
      tariff_selected: null,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BFormRadio,
    BFormRow,
    BFormRadioGroup,
  },
  methods: {
    baseUrl() {
      return `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}`
    },
    async onSubmit(event) {
      try {
        await axios.post(
          `${this.baseUrl()}/api/v1.0/billing/${this.$route.params.inn}/change_tariff`,
          {
            tariff_id: this.tariff_selected,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    try {
      const { data } = await axios.get(
        `${this.baseUrl()}/api/v1.0/billing/short/${this.$route.params.inn}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      /* console.log(`/api/v1.0/billing/short/${this.$route.params.inn}: ` + JSON.stringify(data || {})); */
      this.price = data["price"];
      this.unit = data["unit"];
      this.tariff_id = data["tariff_id"];
    } catch (error) {
      console.log(error);
    }

    this.tariff_selected = this.tariff_id;

    try {
      const tariff_data = await axios.get(
        `${this.baseUrl()}/api/v1.0/tariffs`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(tariff_data.data);
      this.tariff_table = tariff_data.data.items;
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
